import React from 'react';
import { ThreeDotSmallIcon } from '../icons/three-dot-small-icon';
import { ACTIONS_MENU_BTN } from '../../../common/constants/data-hooks';
import { useModal, CommentActionSheetModal } from '../modals';
import styles from './actions-menu-mobile.scss';
const ActionsMenuMobile = (props) => {
    const showModal = useModal();
    const isEmpty = !props.share && !props.edit && !props.delete && !props.report;
    if (isEmpty && !props.showDummy) {
        return null;
    }
    return (React.createElement("button", { className: styles.moreButton, "data-hook": ACTIONS_MENU_BTN, onClick: () => {
            if (!isEmpty) {
                props.onShowMenu?.();
                showModal((toggle) => React.createElement(CommentActionSheetModal, { toggle: toggle, ...props }));
            }
        } },
        React.createElement(ThreeDotSmallIcon, { className: styles.icon })));
};
export default ActionsMenuMobile;
//# sourceMappingURL=actions-menu-mobile.js.map